import { observer } from 'mobx-react';
import { T } from '../../../../../../../Translations';

interface Props {
  onClick: () => void;
  disabled?: boolean;
}

function SaveButton({ onClick, disabled = false }: Props) {
  return (
    <button
      className="px-5 py-2.5 bg-accent text-accent-foreground rounded transition-all hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed"
      style={{ fontSize: 'var(--text-sm)', fontWeight: 'var(--font-weight-medium)' }}
      onClick={onClick}
      disabled={disabled}
      data-intercom-target="builder-v2-save-collection-button"
    >
      <T kind="Save Collection" />
    </button>
  );
}

export default observer(SaveButton);
